// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  border-radius: 5px;
  min-height: 35px;
  width: 100%;
  margin: 0;
  border: none;
  padding: 0px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.button.primary {
  background-color: var(--color-primaryLight);
  color: var(--color-grey000);
}

.button.primary:hover {
  background-color: var(--color-primaryDark);
}

.button.secondary {
  background-color: var(--color-grey050);
}

.button.secondary:hover {
  background-color: var(--color-grey100);
}

.button.simple {
  background-color: transparent;
  color: var(--color-primaryLight);
  border: 3px solid transparent;
}

.button.simple:hover {
  border-color: var(--color-primaryLight);
  background-color: transparent
}

.button.outlined {
  border: 3px solid var(--color-grey500);
  background-color: transparent;
  /* Ensures that the background doesn't change for outlined buttons */
}

/* Outlined primary button */
.button.outlined.primary {
  border-color: var(--color-primaryLight);
  color: var(--color-primaryLight);
}

.button.outlined.primary:hover {
  border-color: var(--color-primaryDark);
  color: var(--color-grey000);
}

/* Outlined secondary button */
.button.outlined.secondary {
  border-color: var(--color-grey050);
}

.button.outlined.secondary:hover {
  border-color: var(--color-grey100);
}

.button.rounded {
  /* border: 3px solid var(--color-grey500); */
  border-radius: 50px;
  background-color: var(--color-grey000);
  width: auto;
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 15px;
  padding-right: 15px;
}

.button.rounded:hover {
  background-color: var(--color-primaryLight);
}

.button.disabled {
  background-color: var(--color-primaryDark);
  border: 3px solid var(--color-primaryDark);
  cursor: not-allowed;
  color: var(--color-grey700);
}

.button.disabled:hover {
  background-color: var(--color-primaryDark);
  border: 3px solid var(--color-primaryDark);
}`, "",{"version":3,"sources":["webpack://./src/components/core/input/Button.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC;AACF;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,oEAAoE;AACtE;;AAEA,4BAA4B;AAC5B;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C","sourcesContent":[".button {\n  border-radius: 5px;\n  min-height: 35px;\n  width: 100%;\n  margin: 0;\n  border: none;\n  padding: 0px;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.button.primary {\n  background-color: var(--color-primaryLight);\n  color: var(--color-grey000);\n}\n\n.button.primary:hover {\n  background-color: var(--color-primaryDark);\n}\n\n.button.secondary {\n  background-color: var(--color-grey050);\n}\n\n.button.secondary:hover {\n  background-color: var(--color-grey100);\n}\n\n.button.simple {\n  background-color: transparent;\n  color: var(--color-primaryLight);\n  border: 3px solid transparent;\n}\n\n.button.simple:hover {\n  border-color: var(--color-primaryLight);\n  background-color: transparent\n}\n\n.button.outlined {\n  border: 3px solid var(--color-grey500);\n  background-color: transparent;\n  /* Ensures that the background doesn't change for outlined buttons */\n}\n\n/* Outlined primary button */\n.button.outlined.primary {\n  border-color: var(--color-primaryLight);\n  color: var(--color-primaryLight);\n}\n\n.button.outlined.primary:hover {\n  border-color: var(--color-primaryDark);\n  color: var(--color-grey000);\n}\n\n/* Outlined secondary button */\n.button.outlined.secondary {\n  border-color: var(--color-grey050);\n}\n\n.button.outlined.secondary:hover {\n  border-color: var(--color-grey100);\n}\n\n.button.rounded {\n  /* border: 3px solid var(--color-grey500); */\n  border-radius: 50px;\n  background-color: var(--color-grey000);\n  width: auto;\n  margin-left: 5px;\n  margin-right: 5px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.button.rounded:hover {\n  background-color: var(--color-primaryLight);\n}\n\n.button.disabled {\n  background-color: var(--color-primaryDark);\n  border: 3px solid var(--color-primaryDark);\n  cursor: not-allowed;\n  color: var(--color-grey700);\n}\n\n.button.disabled:hover {\n  background-color: var(--color-primaryDark);\n  border: 3px solid var(--color-primaryDark);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
